import { Dialog, DialogTrigger, DialogSurface, DialogTitle, DialogBody, DialogActions, DialogContent,Text } from "@fluentui/react-components";
import { Stack, StackItem } from "@fluentui/react";
import { Info20Filled } from "@fluentui/react-icons"
import { dialogBoxStyles, primaryIcon } from "../../styles/customStyles";

export const DynamicDialog=(props:any)=>{
  const mainMenu = sessionStorage.getItem("leftOpenMenu");
  const subMenu = sessionStorage.getItem("leftOpenSubMenu");
  const overlay = sessionStorage.getItem("overlayStatus");


  const styles=
  overlay==="true"?{...dialogBoxStyles,width:"740px",marginTop:'116px', right:"24px"}:
  mainMenu==="true"&&subMenu==="true"?
  {...dialogBoxStyles,width:"calc(100% - 421px)"}
  :mainMenu==="false"&&subMenu==="false"?
  {...dialogBoxStyles,width:"calc(100% - 80px)"}
  :mainMenu==="false"&&subMenu==="true"?
  {...dialogBoxStyles,width:"calc(100% - 270px)"}
  :mainMenu==="true"&&subMenu==="false"?
  {...dialogBoxStyles,width:"calc(100% - 241px)"}
  :{...dialogBoxStyles}

return <Dialog modalType={props.modalType}>
<DialogTrigger disableButtonEnhancement={props.ButtonEnhancement}>
  <Stack> {props.headerButton} </Stack>
</DialogTrigger>
{/* <div style={dialogBoxBackStyles}> */}
<DialogSurface style={styles}>
  <DialogBody>
    <DialogTitle> {props.title} </DialogTitle>
    <DialogContent>
       {props.content} 
    </DialogContent>
    <DialogActions position={props.position}>
      <DialogTrigger disableButtonEnhancement={props.ButtonEnhancement}>
        <Stack horizontal tokens={{childrenGap:30}}>
          <StackItem><Text></Text></StackItem>
          <StackItem> {props.footer} </StackItem>
        </Stack>
      </DialogTrigger>
    </DialogActions>
  </DialogBody>
</DialogSurface>
{/* </div> */}
</Dialog>
}